/**
 * SharedFolderPage
 * Resolves a share link token and navigates to the correct module
 * with the shared folder pre-selected.
 * Accessible to all authenticated users including Viewers.
 */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiClient } from '../services/api';

const SharedFolderPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('Invalid share link.');
      return;
    }
    resolveToken(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const resolveToken = async (linkToken: string) => {
    try {
      const resp = await apiClient.get(`/api/v1/folders/by-token/${linkToken}`);
      const folder = resp.data as any;

      // Navigate to the correct module with the folder pre-selected
      // Test scenario folders → Test Scenarios page
      // Test case folders → Test Cases page
      if (folder.folder_type === 'test_scenario') {
        navigate(`/test-scenarios?folder_id=${folder.id}`, { replace: true });
      } else {
        navigate(`/test-cases?folder_id=${folder.id}`, { replace: true });
      }
    } catch {
      setError('This share link is invalid or has expired.');
    }
  };

  if (error) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '60vh', gap: '1rem',
        fontFamily: 'Inter, sans-serif', color: '#374151'
      }}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p style={{ fontSize: '1rem', color: '#6b7280' }}>{error}</p>
        <button
          style={{ padding: '0.5rem 1.25rem', background: '#0f2d6b', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}
          onClick={() => navigate('/test-scenarios')}
        >
          Go to Test Scenarios
        </button>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '60vh', fontFamily: 'Inter, sans-serif', color: '#9ca3af', fontSize: '0.9rem'
    }}>
      Resolving shared link...
    </div>
  );
};

export default SharedFolderPage;
